import { twMerge } from 'tailwind-merge';
import * as React from 'react';
import PropTypes from 'prop-types';
import { FieldWrapper } from '../../Form/FieldWrapper';

export const Textarea = React.forwardRef(
  (
    {
      label = '',
      className,
      registration,
      error,
      placeholder = 'Write something..',
      rows = 5,
      defaultValue = '',
      value,
      disabled = false,
      wrapperClassName,
      name,
      labelClassName,
      labelTextClassName,
      onKeyDown,
      onChange,
    },
    ref
  ) => {
    return (
      <FieldWrapper
        label={label}
        error={error}
        wrapperClassName={wrapperClassName}
        className={labelClassName}
        labelTextClassName={labelTextClassName}
      >
        <textarea
          name={name}
          ref={ref}
          onKeyDown={onKeyDown}
          className={twMerge(
            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500',
            className
          )}
          {...registration}
          rows={rows}
          onChange={onChange}
          disabled={disabled}
          defaultValue={defaultValue}
          value={value}
          placeholder={placeholder}
        />
      </FieldWrapper>
    );
  }
);

Textarea.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  rows: PropTypes.number,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
};
